import { render, staticRenderFns } from "./PointTermsOfService.vue?vue&type=template&id=592e261a&scoped=true&"
import script from "./PointTermsOfService.vue?vue&type=script&lang=js&"
export * from "./PointTermsOfService.vue?vue&type=script&lang=js&"
import style0 from "./PointTermsOfService.vue?vue&type=style&index=0&id=592e261a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "592e261a",
  null
  
)

export default component.exports